import { RaceOdds } from "@tvg/ts-types/Race";

export const getRunnerOdds = (odds: RaceOdds | null) =>
  odds && odds.numerator ? `${odds.numerator}/${odds.denominator || 1}` : "99";
